const initialState = {
    product: {
        fecha_desde: "",
        fecha_hasta: "",
        id_categoria_comercial: null,
        id_producto: null,
        id_proveedor: null,
        id_tipo_producto: null,
        id_tipo_contrato: null,
        numero_contrato: "",
        periodicidad: "",
        valor_tarifa: "",
        politica_beneficios: "",
        causal_cambio_estado: "",
        estado: 1,
        dataState: {
            estados: [
                { text: "ACTIVO", value: 1 },
                { text: "INACTIVO", value: 0 },
            ],
            periodicidades: [
                { texto: "Mensual", periodicidad: "M" },
                { texto: "Bimestral", periodicidad: "B" },
                { texto: "Trimestral", periodicidad: "T" },
                { texto: "Anual", periodicidad: "A" }
            ],
            proveedores: [],
            tiposBeneficios: [],
            tiposProductos: [],
            productos: [],
            tiposContratos: [],
            contratos: [],
        }
    }
};

const state = {
    productsUser: [],
    product: { ...initialState.product },
};

export { state, initialState };